import { UnknownAction } from 'redux';
import { UserState, FunctionMap } from '../../types';
import { SetUser, SetUserSetting } from '../actions';
import { SET_USER, SET_USER_SETTING } from '../constants';
import { createReducer } from './Utils';
import set from 'lodash/fp/set';

const userDefaultState: UserState = {
  user: undefined,
  settings: {},
};

function setUser(state: UserState, action: SetUser) {
  return { ...state, user: action.user };
}

function setUserSetting(state: UserState, action: UnknownAction & SetUserSetting) {
  const modifiedUser = set(['settings', action.setting], action.value, state);
  return modifiedUser;
}

const functionMap: FunctionMap = {
  [SET_USER]: setUser,
  [SET_USER_SETTING]: setUserSetting,
};

export default createReducer(functionMap, userDefaultState);
